export default __webpack_public_path__ + "static/media/notstarted.0d886436.svg";